// src/components/atom/BackgroundImages.js
import backgroundCloudy from '../../assets/backgroundImages/background_cloudy.png';
import backgroundThunder from '../../assets/backgroundImages/thunder.jpg';
import backgroundSun from '../../assets/backgroundImages/sunBackground.jpg';
import backgroundRain from '../../assets/backgroundImages/rainBackground.jpg';
import backgroundSnow from '../../assets/backgroundImages/snowBackground.jpg';
import backgroundFog from '../../assets/backgroundImages/fogBackground.jpg';
import backgroundStars from '../../assets/backgroundImages/clearBackground.jpg'

const BACKGROUND_IMAGES = {
  clouds: backgroundCloudy,
  thunder: backgroundThunder,
  sunny: backgroundSun,
  rain: backgroundRain,
  snow: backgroundSnow,
  fog: backgroundFog,
  clear: backgroundStars
};

const BackgroundImage = ({ name }) => {
  return BACKGROUND_IMAGES[name] || null; // Gibt den Pfad des Bildes zurück oder null
};

export default BackgroundImage;
